import { z } from 'zod'

/** Şifre politikası: en az 8 karakter, 1 büyük harf, 1 rakam */
export const StrongPasswordSchema = z
  .string({ required_error: 'Şifre zorunludur.' })
  .min(8, 'Şifre en az 8 karakter olmalıdır.')
  .regex(/[A-Z]/, 'Şifre en az 1 büyük harf içermelidir.')
  .regex(/[0-9]/, 'Şifre en az 1 rakam içermelidir.')

export const LoginSchema = z.object({
  email: z
    .string({ required_error: 'E-posta adresi zorunludur.' })
    .email('Geçerli bir e-posta adresi giriniz.'),
  password: z
    .string({ required_error: 'Şifre zorunludur.' })
    .min(1, 'Şifre zorunludur.'),
  rememberMe: z.boolean().optional().default(false),
})

export const RefreshTokenSchema = z.object({
  refreshToken: z.string({ required_error: 'Refresh token zorunludur.' }),
})

export const ForgotPasswordSchema = z.object({
  email: z
    .string({ required_error: 'E-posta adresi zorunludur.' })
    .email('Geçerli bir e-posta adresi giriniz.'),
})

export const ResetPasswordSchema = z
  .object({
    token: z.string({ required_error: 'Token zorunludur.' }),
    password: StrongPasswordSchema,
    passwordConfirm: z.string({ required_error: 'Şifre tekrarı zorunludur.' }),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: 'Şifreler eşleşmiyor.',
    path: ['passwordConfirm'],
  })

export const SetInitialPasswordSchema = z
  .object({
    token: z.string({ required_error: 'Aktivasyon token zorunludur.' }),
    password: StrongPasswordSchema,
    passwordConfirm: z.string({ required_error: 'Şifre tekrarı zorunludur.' }),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: 'Şifreler eşleşmiyor.',
    path: ['passwordConfirm'],
  })

export type LoginInput = z.infer<typeof LoginSchema>
export type RefreshTokenInput = z.infer<typeof RefreshTokenSchema>
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordSchema>
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>
export type SetInitialPasswordInput = z.infer<typeof SetInitialPasswordSchema>
